import React from 'react';
import PropTypes from 'prop-types';
import Modal, { ModalActions, ModalTitle, ModalBody } from '@strava/ui/Modal';
import Button from '@strava/ui/Button';
import Tooltip from '@strava/ui/Tooltip';
import NavigationHelpNormalXsmall from '@strava/icons/NavigationHelpNormalXsmall';
import I18n from 'utils/I18n';
import { Markup } from 'interweave';
import { authorizationUrlsProps } from '../../shared/prop-types';

import 'react-dropdown/style.css';

import styles from './index.scss';
import DisclaimerText from '../DisclaimerText';

const SignupAgeGateModal = ({
  open,
  signupOption,
  // eslint-disable-next-line no-unused-vars
  authorizationUrls,
  onDismissCallback
}) => {
  const I18nPrefix = 'strava.landing_page';

  return (
    <Modal
      className={styles.modal}
      isOpen={open}
      onDismiss={onDismissCallback}
      hasClose={true}
    >
      <ModalTitle className={styles.modalTitle}>
        {I18n.t(`${I18nPrefix}.before_you_sign_up`)}
      </ModalTitle>
      <ModalBody className={styles.modalBody}>
        <div className={styles.subtitle}>
          <div className={styles.text}>{I18n.t(`${I18nPrefix}.birthday`)}</div>
          <Tooltip
            label={
              <Markup noWrap={true} content={I18n.t(`${I18nPrefix}.why_dob`)} />
            }
            position="top"
            className={styles.toolTip}
          >
            <NavigationHelpNormalXsmall />
          </Tooltip>
        </div>

        <div className={styles.dateSelector}>
          [datepicker placeholder] option: {signupOption}
        </div>

        <DisclaimerText showLoginOption={false} />
      </ModalBody>
      <ModalActions className={styles.modalActions}>
        <Button type="button" variant="primary" className={styles.signupButton}>
          {I18n.t(`${I18nPrefix}.agree_and_signup`)}
        </Button>
      </ModalActions>
    </Modal>
  );
};

SignupAgeGateModal.propTypes = {
  open: PropTypes.bool.isRequired,
  signupOption: PropTypes.oneOf(['facebook', 'google', 'email']),
  authorizationUrls: authorizationUrlsProps.isRequired,
  onDismissCallback: PropTypes.func.isRequired
};

SignupAgeGateModal.defaultProps = {
  signupOption: null
};

export default SignupAgeGateModal;
